import React from 'react';
import { useBulkApproval } from '../../contexts/BulkApprovalContext';

/**
 * Globalny pasek postepu masowego zatwierdzania faktur zakupu.
 * Renderowany w Layout (zamontowany na kazdej podstronie), wiec pasek jest
 * widoczny przez cala operacje niezaleznie od tego, na ktorej stronie jestes.
 */
const BulkApprovalBanner = () => {
  const { running, done, total, current, progressPct } = useBulkApproval();
  if (!running) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 4000,
      backgroundColor: 'var(--card-bg)', borderBottom: '2px solid var(--success)',
      boxShadow: '0 2px 12px rgba(0,0,0,0.25)', padding: '10px 16px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: 600, color: 'var(--text)' }}>
          <span style={{
            width: '14px', height: '14px', border: '2px solid var(--success)',
            borderTopColor: 'transparent', borderRadius: '50%',
            display: 'inline-block', animation: 'v3bulkspin 0.7s linear infinite',
          }} />
          Zatwierdzanie faktur: {done}/{total}
          {current && (
            <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>
              — teraz: {current}
            </span>
          )}
        </div>
        <div style={{ fontSize: '12px', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
          {progressPct}%
        </div>
      </div>
      <div style={{ marginTop: '8px', height: '6px', backgroundColor: 'var(--bg)', borderRadius: '3px', overflow: 'hidden', maxWidth: '900px', margin: '8px auto 0' }}>
        <div style={{
          height: '100%', width: `${progressPct}%`,
          backgroundColor: 'var(--success)', transition: 'width 0.2s ease',
        }} />
      </div>
      <style>{`@keyframes v3bulkspin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default BulkApprovalBanner;
